export default __webpack_public_path__ + "b2bfd12ed6e758d5c291f322fc38d38f92f2cee4c00e3999b8f1c7518382fe86.svg";